import { authReducer } from "./authReducer";
import { contractReducer } from "./contractReducer";
import { siniesterReducer } from "./siniesterReducer";
import { createStore, combineReducers } from "redux";

const reducer = combineReducers({auth: authReducer, contract: contractReducer, siniester: siniesterReducer})
const store = createStore(reducer);


export default store;